export default __webpack_public_path__ + "static/media/Shin-pads of the Dark Messenger.a14ef8aa.jpg";